// extracted by mini-css-extract-plugin
export default {"info":"LinkBlockedModal_info__zH1mX","link":"LinkBlockedModal_link__oeZs+"};